export default "__VITE_ASSET__528c0260__"